
































































































/** @format */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { postSmsNotice, getSmsTemplateCon, getSmsTemplateConfig } from '@/api/setting-management';

@Component({
  name: 'SelfServiceSetting',
  components: {
    InputNumverList: () => import('./components/input-number-list.vue')
  }
})
export default class SelfServiceSetting extends Vue {
  // Type
  @Prop({ type: String, default: '' }) type!: string;

  // 机构ID
  @Prop({ type: String, default: '' }) organizationId!: string;

  // 车场ID
  @Prop({ type: String, default: '' }) parkId!: string;

  // 分类
  @State(state => state.dictionaries.allDictionaries['payment_card_type'])
  carTypeMap;

  @Watch('formParams')
  onChildChanged() {}

  @Watch('parkId')
  onParkIdChanged() {
    this.initData();
  }
  /**
   *
   */
  private form;
  /**
   *
   */
  private smsContentMap = {};
  private smsConfigList = [];
  /**
   *
   */
  private formParams = {};
  private status = 'loading';
  private error = '';
  private saveing = false;
  /**
   *
   */
  private isDisabled = true;
  private handleEdit() {
    this.isDisabled = false;
  }
  /**
   *
   */
  handleDayNumber(id, value) {
    value = value.map(it => parseInt(it || 0));
    this.form.setFieldsValue({
      [`days-${id}`]: value.join(',')
    });
  }

  getNumberList(carType) {
    const arr = this.form.getFieldValue(`days-${carType}`) || '';

    return arr ? arr.split(',') : [];
  }

  isDisabledInput(carType) {
    if (this.isDisabled) return true;
    return !this.form.getFieldValue(`enabled-${carType}`);
  }

  /**
   *  提交表单
   */
  private async handleEditSubmit(e) {
    try {
      e.preventDefault();
      this.saveing = true;
      const parkId = this.parkId;

      const values = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values: any) => {
          if (err) return reject(new Error('缺少参数'));
          resolve(values);
        });
      });

      const content = [];

      this.smsConfigList.forEach(it => {
        const days = values[`days-${it.carType}`];
        const enabled = values[`enabled-${it.carType}`];
        if (enabled === true && !days) throw new Error(`请设置逾期短信提醒天数`);

        content.push({
          parkId,
          enabled: enabled ? '01' : '00',
          days,
          smsId: values[`smsId-${it.carType}`],
          carType: it.carType,
          id: it.pkSmsNotice
        });
      });

      if (!content.length) throw new Error(`没有可提交的参数; content=${content}`);

      const { status, msg } = await postSmsNotice(content);

      if (status !== '9999') throw new Error(msg || '服务无响应，请重试！');

      this.$message.success('提交成功');
      this.isDisabled = true;
    } catch (err) {
      this.$message.error(err.message);
    } finally {
      this.saveing = false;
    }
  }
  /**
   *  取消表单
   */
  private handleResetData() {
    this.isDisabled = true;
  }
  msgSelectList: any[];
  /**
   * 初始化数据
   */
  async initData() {
    if (!this.parkId) {
      this.error = '缺少parkId参数，请选择车场节点查看';
      return;
    } else {
      this.error = '';
    }
    this.status = 'loading';
    try {
      const smsCon = await getSmsTemplateCon();

      if (smsCon.status !== '9999') throw new Error(smsCon.msg || '获取短信模版失败');
      this.msgSelectList =
        smsCon.data &&
        smsCon.data.map((item, i) => {
          this.smsContentMap[item.pkSms] = item.content;
          return { name: `短信模版${i}`, ...item };
        });

      const smsTmp = await getSmsTemplateConfig(this.parkId);

      if (smsTmp.status !== '9999') throw new Error(smsTmp.msg || '获取长租, 产权短信配置失败');
      const formParams = {};
      const smsConfigList = Object.keys(this.carTypeMap).map(carType => {
        const { advanceDay = '', enabled = '00', pkSmsNotice = '', smsId = '' } =
          (smsTmp.data || []).find(it => it.carType === carType) || {};

        Object.assign(formParams, {
          [`days-${carType}`]: advanceDay,
          [`enabled-${carType}`]: enabled === '01',
          [`smsId-${carType}`]: smsId
        });
        return {
          advanceDay,
          carType,
          enabled,
          pkSmsNotice,
          smsId,
          subtitle: `在${carType === '01' ? '产权' : '月卡'}逾期前提前短信通知业主`
        };
      });

      this.form = this.$form.createForm(this, {
        name: 'self-service-setting-form',
        mapPropsToFields: () => {
          for (let m in formParams) {
            formParams[m] = this.$form.createFormField({
              value: formParams[m]
            });
          }
          return formParams;
        }
      });
      // this.form.setFieldsValue();

      this.smsConfigList = smsConfigList;
    } catch (err) {
      this.error = err.message || '获取短信模版失败';
      this.$message.error(this.error);
    } finally {
      this.status = 'finish';
      this.isDisabled = true;
    }
  }
  created() {
    /**
     * 初始化form
     */
    this.initData();
  }

  activated() {
    this.initData();
  }
}
